import App from './App';
import Drinks from './Drinks';
import Menu from './Menu';
import base_url from './base_url';

const Homepage = (function () {

  let state = {
    page: 'menu',
    drinks: [],
    menu: {},
    content: {},
    lang: null
  }

  function _getDrinks(callback) {
    $.ajax({
      url: base_url + '/m_2/api/drinks/get',
      method: 'GET',
      success: function (response) {
        response = JSON.parse(response);
        state.drinks = response;
        console.log(response);
        if (callback) {
          callback();
        }
      },
      error: function (error) {
        console.log(error);
      }
    })
  }

  function _getDrinkCategories(callback) {
    $.ajax({
      url: base_url + '/m_2/api/drinks/get_categories',
      method: 'GET',
      success: function (response) {
        response = JSON.parse(response);
        state.drink_categories = response;
        console.log(response);
        if (callback) {
          callback();
        }
      },
      error: function (error) {
        console.log(error);
      }
    })
  }

  function _parseMenu(menu) {
    let new_menu = {
      main: {
        en: [],
        hu: []
      },
      starters: {
        en: [],
        hu: []
      },
      desserts: {
        en: [],
        hu: []
      }
    };
    menu.forEach(item => {
      let en = {name: item.en_title, price: item.price}
      let hu = {name: item.hu_title, price: item.price}
      new_menu[item.category]['en'].push(en);
      new_menu[item.category]['hu'].push(hu);
    })
    return new_menu;
  }

  function _getMenu(callback) {
    $.ajax({
      url: base_url + '/m_2/api/menu/get',
      method: 'GET',
      success: function (response) {
        response = JSON.parse(response);
        console.log(response);
        let menu = _parseMenu(response);
        state.menu = menu;
        console.log(menu)
        if (callback) {
          callback();
        }
      },
      error: function (error) {
        console.log(error);
      }
    })
  }

  function _parseContent(content) {
    let parsedContent = {
      en: {},
      hu: {}
    };
    content.forEach(c => c.lang === 'en' ? parsedContent.en = c : parsedContent.hu = c)
    return parsedContent;
  }

  function _getContent(callback) {
    $.ajax({
      url: base_url + '/m_2/api/content/get',
      method: 'GET',
      success: function (response) {
        response = JSON.parse(response);
        console.log(response);
        let content = _parseContent(response);
        state.content = content;
        console.log(content)
        if (callback) {
          callback();
        }
      },
      error: function (error) {
        console.log(error);
      }
    })
  }

  function _renderStatic() {
    let lang = state.lang;
    _getContent(() => {
      $('.phone').html(state.content[lang].phone);
      $('.cim').html(state.content[lang].address);
      $('.a0').html(state.content[lang].open);
      $('.a').html(state.content[lang].open1);
      $('.b').html(state.content[lang].open2);
      $('.text p').html(state.content[lang].papagaj);
      $('.reservation-btn').html(lang === "hu" ? "Asztalfoglalás" : "Reservation").hide();
      $('.reservation-btn').attr('href', lang === "hu" ? "reservation/#/hu" : "reservation/#/en");

      $('.logo').removeClass('en').removeClass('hu').addClass(lang);
      $('.logo img').attr('src', 'assets/img/' + lang + '_logo_mobile.png');

      $('.flag').removeClass('en').removeClass('hu').addClass(lang);
      $('.flag a').removeClass('en').removeClass('hu').addClass(lang);
      $('.flag a').attr('href', '#/' + (lang === 'hu' ? 'en' : 'hu'));

      $('.buttons .map').attr('href', '#/' + lang + '/map');
      $('.buttons .etlap').attr('href', '#/' + lang);
      $('.buttons .drink').attr('href', '#/' + lang + '/drinks');
    })
  }

  function _render() {
    _renderStatic();
    if (state.page === 'drinks') {
      console.log('page drinks')
      if (!state.drinks.length) {
        _getDrinks(() => {
          _getDrinkCategories(() => {
            $('.box').html(Drinks.render(state.drink_categories, state.drinks, state.lang));
          });
        });
      } else {
        $('.box').html(Drinks.render(state.drink_categories, state.drinks, state.lang));
      }
      $('.drink').addClass('selected');
      $('.etlap').removeClass('selected');
    } else if (state.page === "home") {
      console.log('page menu')
      if (Object.keys(state.menu).length) {
        $('.box').html(Menu.render(state.menu, state.lang))
      } else {
        _getMenu(() => {
          $('.box').html(Menu.render(state.menu, state.lang))
        })
      }
      $('.etlap').addClass('selected');
      $('.drink').removeClass('selected');
    } else if (state.page === 'map') {
      $('.box').html(`
          <a href="https://www.google.com/maps/preview#!q=Budapest%2C+Kert%C3%A9sz+u.+48%2C+Hongrie&amp;data=!4m15!2m14!1m13!1s0x4741dc6f29d4bc7b%3A0xa4a710686fa0794e!3m8!1m3!1d26081603!2d-95.677068!3d37.0625!3m2!1i1440!2i768!4f13.1!4m2!3d47.5023316!4d19.0647985" target="_blank">
            <img src="assets/img/${state.lang}_terkep.png" alt="" class="terkep">
          </a>
      `)
    }
  }

  function _setupListeners() {
    $(window).on('hashchange', function() {
      state.lang = window.location.hash.split('/')[1];
      state.page = window.location.hash.split("/")[2] ? window.location.hash.split("/")[2] : "home";
      _render();
    })
  }

  return {
    init: () => {
      console.log(window.location.hash)
      state.lang = window.location.hash.split('/')[1];
      state.page = window.location.hash.split("/")[2] ? window.location.hash.split("/")[2] : "home";
      console.log('homepage init')
      _setupListeners();
      _render();
      //$('.stuff').html(_content());
    }
  }
})();

export default Homepage;


// WEBPACK FOOTER //
// ./src/Homepage.js